module.exports = __webpack_public_path__ + "img/AI_02.d53e0947.jpg";